import { render } from "./CharacterList.vue?vue&type=template&id=9d619b52&scoped=true"
import script from "./CharacterList.vue?vue&type=script&lang=js"
export * from "./CharacterList.vue?vue&type=script&lang=js"

import "./CharacterList.vue?vue&type=style&index=0&id=9d619b52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d619b52"]])

export default __exports__